export default __webpack_public_path__ + "static/media/close.58a91a72.svg";